import React, { useState } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const generateColors = (length) => {
  return Array.from({ length }, (_, i) => {
    const hue = Math.floor((360 / length) * i); // Bagi merata di roda warna
    return `hsl(${hue}, 70%, 60%)`;
  });
};

const PieChartSumberInformasi = (props) => {
    const {data: dataSumber, dataSemua} = props

    const formattedData = dataSumber.map(item => ({
        ...item,
        total: parseInt(item.total, 10),
    }));

    const formattedDataSemua = dataSemua.map(item => ({
        ...item,
        total: parseInt(item.total, 10),
    }));

  const COLORS = generateColors(formattedData.length);
  const COLORS_SEMUA = generateColors(formattedDataSemua.length);

  const [tab, setTab] = useState('semua')

  return (
    <div style={{ width: '100%', height: 400, marginBottom: 200 }}>
      <h3>Sumber Informasi</h3>

        <div className='tab'>
            <div onClick={() => setTab('semua')} className={tab == 'semua' ? 'active' : ''}>Semua</div>
            <div onClick={() => setTab('saya')} className={tab == 'saya' ? 'active' : ''}>Saya</div>
        </div>

{
    tab == 'saya' && <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={formattedData}
            dataKey="total"
            nameKey="sumber_informasi"
            cx="50%"
            cy="45%"
            outerRadius={100}
            label={({ sumber_informasi, percent }) =>
              `${sumber_informasi} (${(percent * 100).toFixed(0)}%)`
            }
          >
            {formattedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={80} />
        </PieChart>
      </ResponsiveContainer>
}
      
      {
    tab == 'semua' && <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={formattedDataSemua}
            dataKey="total"
            nameKey="sumber_informasi"
            cx="50%"
            cy="45%"
            outerRadius={100}
            label={({ sumber_informasi, percent }) =>
              `${sumber_informasi} (${(percent * 100).toFixed(0)}%)`
            }
          >
            {formattedDataSemua.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS_SEMUA[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={80} />
        </PieChart>
      </ResponsiveContainer>
}

    </div>
  );
};

export default PieChartSumberInformasi;
